<div class="wrapper">
  @if (isDataLoaded()) {
    <page-title></page-title>

    <nav class="action-nav-right">
      <div class="header-action-group primary-action-group">
        @if (isTimeTrackingEnabled()) {
          <play-button
            [currentTask]="currentTask()"
            [currentTaskId]="currentTaskId()"
            [currentTaskContext]="currentTaskContext()"
            [hasTrackableTasks]="hasTrackableTasks()"
          ></play-button>
        }

        @if (showDesktopButtons()) {
          <button
            emlDrop
            (click)="layoutService.showAddTaskBar()"
            matTooltip="{{ T.MH.ADD_NEW_TASK | translate }} {{
              kb.addNewTask ? '[' + kb.addNewTask + ']' : ''
            }}"
            class="tour-addBtn"
            color="primary"
            mat-icon-button
          >
            <mat-icon>add</mat-icon>
          </button>
        }
      </div>

      <div class="header-action-group secondary-action-group counters-action-group">
        <!-- Focus button: keep the entry point discoverable on desktop and mobile. -->
        @if (isFocusButtonVisible()) {
          <focus-button></focus-button>
        }
        @if (showDesktopButtons()) {
          @for (
            simpleCounter of enabledSimpleCounters();
            track trackById($index, simpleCounter)
          ) {
            @if (!simpleCounter.isHideButton) {
              <simple-counter-button
                [matTooltip]="simpleCounter.title"
                [simpleCounter]="simpleCounter"
              ></simple-counter-button>
            }
          }
        }
      </div>

      @if (isSyncIconEnabled()) {
        <!--
          matBadgeHidden only hides the badge VISUALLY (CSS) — MatBadge keeps an
          aria description active regardless of hidden state. So at count 0 the
          badge description must be empty (not a stale "0 conflicts" announced to
          screen readers on every encounter). '' is the type-correct
          "no description" value; MatBadge removes the aria-describedby for it.
        -->
        <button
          class="sync-btn secondary-header-action"
          [class.is-error]="syncIsEnabledAndReady() && syncState() === 'ERROR'"
          [class.is-offline]="syncIsEnabledAndReady() && !isOnline()"
          [class.is-in-progress]="syncIsEnabledAndReady() && isSyncInProgress()"
          [matBadge]="unreviewedConflictCount()"
          [matBadgeHidden]="unreviewedConflictCount() === 0"
          matBadgeColor="accent"
          matBadgeSize="small"
          matBadgeOverlap="true"
          [matBadgeDescription]="
            unreviewedConflictCount() > 0
              ? (T.F.SYNC.CONFLICT_REVIEW.BADGE_TOOLTIP
                | translate: { count: unreviewedConflictCount() })
              : ''
          "
          [attr.aria-label]="syncTooltip() | translate"
          matTooltip="{{ syncTooltip() | translate }}"
          (click)="onSyncButtonClick()"
          (longPress)="setupSync()"
          (contextmenu)="$event.preventDefault(); setupSync()"
          mat-icon-button
        >
          @if (syncIsEnabledAndReady()) {
            @if (isOnline()) {
              @if (syncState() === 'ERROR') {
                <mat-icon>sync_problem</mat-icon>
              } @else {
                <mat-icon [class.spin]="isSyncInProgress()">sync</mat-icon>
              }
              @if (hasNoPendingOps()) {
                @if (superSyncIsConfirmedInSync()) {
                  <mat-icon class="sync-state-ico">done_all</mat-icon>
                } @else {
                  <mat-icon class="sync-state-ico">check</mat-icon>
                }
              }
            } @else {
              <mat-icon>wifi_off</mat-icon>
            }
          } @else {
            <mat-icon>sync_disabled</mat-icon>
          }
        </button>
      }

      <plugin-work-context-header-btns
        class="secondary-header-action"
      ></plugin-work-context-header-btns>
      <plugin-header-btns class="secondary-header-action"></plugin-header-btns>

      @if (isUserProfilesEnabled()) {
        <user-profile-button class="secondary-header-action"></user-profile-button>
      }

      <!-- Desktop: Show all buttons inline -->
      @if (showDesktopButtons()) {
        <plugin-side-panel-btns class="secondary-header-action"></plugin-side-panel-btns>

        <desktop-panel-buttons
          class="secondary-header-action"
          [kb]="kb"
          [isRouteWithSidePanel]="isRouteWithSidePanel()"
          [isShowScheduleDayPanel]="isShowScheduleDayPanel()"
          [isShowIssuePanel]="isShowIssuePanel()"
          [isShowNotes]="isShowNotes()"
        ></desktop-panel-buttons>
      }

      <!-- Simple Counter Dropdown (mobile only) -->
      @if (isXs()) {
        @if (enabledSimpleCounters().length) {
          <div class="header-action-group secondary-action-group mobile-dropdown-wrapper">
            <button
              (click)="
                isShowSimpleCounterBtnsDropdown.set(!isShowSimpleCounterBtnsDropdown())
              "
              [color]="isCounterRunning(enabledSimpleCounters()) ? 'accent' : ''"
              aria-controls="mobile-simple-counter-menu"
              [attr.aria-expanded]="isShowSimpleCounterBtnsDropdown()"
              [attr.aria-label]="T.F.METRIC.CMP.SIMPLE_COUNTERS | translate"
              mat-icon-button
              type="button"
            >
              <mat-icon>{{
                isShowSimpleCounterBtnsDropdown() ? 'close' : 'timer'
              }}</mat-icon>
            </button>
            <div
              id="mobile-simple-counter-menu"
              class="mobile-dropdown"
              [class.isVisible]="isShowSimpleCounterBtnsDropdown()"
              [attr.aria-hidden]="!isShowSimpleCounterBtnsDropdown()"
              [attr.inert]="isShowSimpleCounterBtnsDropdown() ? null : ''"
            >
              @for (
                simpleCounter of enabledSimpleCounters();
                track trackById($index, simpleCounter)
              ) {
                @if (!simpleCounter.isHideButton) {
                  <simple-counter-button
                    [simpleCounter]="simpleCounter"
                  ></simple-counter-button>
                }
              }
            </div>
          </div>
        }
      }
    </nav>
  }
</div>
